import { dashboardConstants } from "./dashboardConstants";

import { strings } from "../../helpers";

export const ticketListProcessing = isProcessing => {
  return { type: dashboardConstants.TICKETS_LIST_PROCESSING, isProcessing };
};
export const ticketListSuccess = tickets => {
  return { type: dashboardConstants.TICKETS_LIST_SUCCESS, tickets };
};
export const totalRecords = totalRecords => {
  return { type: dashboardConstants.TOTAL_RECORDS_SUCCESS, totalRecords };
};
export const ticketListFailure = error => {
  return { type: dashboardConstants.TICKETS_LIST_FAILURE, error };
};
export const inboxUnreadMark = mark => {
  return { type: dashboardConstants.INBOX_UNREAD_SUCCESS, mark };
};
export const unreadRoomsAction = rooms => {
  return { type: dashboardConstants.ROOMS_UNREAD_SUCCESS, rooms };
};

/**
 * @function getTickets
 * @param coordinaterId - selected coordinator Id
 * @param status - filter status
 * @param page - active page
 * @desc Called when coordinator from the dropdown is changed
 */
export const getTickets = (coordinaterId, status, page, searchText) => {
  return dispatch => {
    dispatch(ticketListProcessing(true));
  };
};

export const coordinatorsListProcessing = isProcessing => {
  return {
    type: dashboardConstants.COORDINATORS_LIST_PROCESSING,
    isProcessing
  };
};
export const coordinatorsListSuccess = coordinatorsList => {
  return {
    type: dashboardConstants.COORDINATORS_LIST_SUCCESS,
    coordinatorsList
  };
};
export const coordinatorsListFailure = error => {
  return { type: dashboardConstants.COORDINATORSLIST_FAILURE, error };
};
